import styled, { css } from 'styled-components';

interface TootipProps {
  bgColor: string;
  color: string;
}

export const Container = styled.div<TootipProps>`
  position: relative;

  span {
    ${(props) =>
      css`
        background: ${props.bgColor};
        color: ${props.color};
      `}
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    width: 160px;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;

    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);

    &::before {
      content: '';
      border-style: solid;
      ${(props) =>
        css`
          border-color: ${props.bgColor} transparent;
        `}
      border-width: 6px 6px 0 6px;
      bottom: 20px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
